import { createElement } from "react";
import { ofArray, singleton } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { Interop_reactApi } from "../../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { createObj } from "../../../../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_combineClasses } from "../../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Corpus } from "../../../../fs/Model/Model.js";
import { partsOfSpeech } from "./Cwb.js";
import { metadataDistributionCategories, quickView, selectionTable, menu } from "./Metadata.js";

export function dataFileButtons(textId) {
    let props_2, elems_1, elms;
    const pdfFile = `${textId}.pdf`;
    return singleton((props_2 = ofArray([["className", "is-info"], ["className", "is-small"], ["style", {
        marginRight: 5,
    }], ["data-tooltip", "Student paper"], ["className", "has-tooltip-right"], ["href", `http://tekstlab.uio.no/norm/oppgavesvar/${pdfFile}`], ["target", "_blank"], (elems_1 = [(elms = singleton(createElement("i", {
        className: "fa-regular fa-file",
    })), createElement("span", {
        className: "icon",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), createElement("a", createObj(Helpers_combineClasses("button", props_2)))));
}

export function getCorpus(config) {
    return new (class extends Corpus {
        constructor() {
            super(config, singleton(partsOfSpeech), menu, selectionTable, quickView, metadataDistributionCategories);
        }
        ["Model.Corpus.ResultLinksZ731E88D3"](_arg1, _arg2, textId, _arg3, corpusInfo) {
            let elems;
            const props = ofArray([["style", {
                justifyContent: "center",
            }], (elems = dataFileButtons(textId), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]);
            return createElement("div", createObj(Helpers_combineClasses("buttons", props)));
        }
        ["Model.Corpus.SelectionTableFirstColumnZ3081B86A"](textId_1, corpusInfo_1) {
            let elems_1;
            return createElement("td", {
                style: {
                    whiteSpace: "nowrap",
                    paddingRight: 0,
                },
                children: createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "nowrap",
                }], (elems_1 = dataFileButtons(textId_1), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))),
            });
        }
    }
    )();
}

